import React, { Component } from "react";
import { Provider } from "react-redux";
import logo from "./logo.svg";
import "./App.css";

import store from "whiteboard/AppStore";

import AppRoot from "views/AppRoot";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <div className="App">
          <AppRoot />
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js